var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_183_12120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 11.8638L12 14.8638L20 6.86377",
    stroke: "#00D094",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12.8638V18.8638C20 19.3942 19.7893 19.9029 19.4142 20.278C19.0391 20.6531 18.5304 20.8638 18 20.8638H6C5.46957 20.8638 4.96086 20.6531 4.58579 20.278C4.21071 19.9029 4 19.3942 4 18.8638V6.86377C4 6.33334 4.21071 5.82463 4.58579 5.44956C4.96086 5.07448 5.46957 4.86377 6 4.86377H15",
    stroke: "#00D094",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_183_12120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.86377)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.d2be67ef53be7c0187dbb62e6e69e54c.svg";
export { ForwardRef as ReactComponent };